import { RootState } from "./types";
import { get } from "lodash";
import { formatRegionUrl } from "@/utils/string-utils";
import api from "@/services/api.service";

export const getters = {
	isLoggedIn: (state: RootState) => state.User.loggedIn,
	isAppInitialised: (state: RootState) => state.appInitialised,
	getUserName: (state: RootState) => state.User.fullName,
	getLoginError: (state: RootState) => state.User.error,
	getDataError: (state: RootState) => state.dataError,
	getShortcuts: (state: RootState) => state.keyboardShortcuts,
	getLegendKeys: (state: RootState) => state.legendKeys,
	isFullUser: (state: RootState) => state.User.isFullUser,
	getTimeZoneAbbr: (state: RootState) => state.timeZoneAbbr,
	getUserGroups: (state: RootState) => state.UserGroups,
	getShowRoutingGroupsLegend: (state: RootState) => state.showRoutingGroupsLegend,
	getPermissions: (state: RootState) => state.User.userPermissions,
	getUseImperialMeasurements: (state: RootState) => state.User.useImperialMeasurements,
	getMapType: (state: RootState) => state.User.mapType,
	getHideLabels: (state: RootState) => state.User.hideLabels,
	getRequireMapPin: (state: RootState) => state.User.requireMapPin,
	getRoutingGroups: (state: RootState) => state.routingGroups,
	getAlarmScreenTimeoutSeconds: (state: RootState) => state.User.alarmScreenTimeoutSeconds,
	getAlarmAgeWarningSeconds: (state: RootState) => state.User.alarmAgeWarningSeconds,
	getDbFederationEnabled: (state: RootState) => state.User.dbFederationEnabled,
	getVersion: (state: RootState) => state.version,
	getServerName: (state: RootState) => state.serverName,
	getMapKey: (state: RootState) => state.User.mapKey || process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
	getMediaMatrixState: (state: RootState) => state.User.mediaMatrixState,
	getFeaturesList: (state: RootState) => state.featuresList,
	getFeature: state => (featureNames: string[]) => {
		return get(state.featuresList, featureNames, false);
	},
	getUserId: (state: RootState) => state.User.userId,
	getUserGroupId: (state: RootState) => state.User.userGroupId,
	getMaskMaxHours: (state: RootState) => {
		if (state.User.userPermissions.canDisarmSitesExtended) {
			return 72;
		} else if (state.User.userPermissions.canDisarmSites) {
			return 24;
		}
	},
	getTimeZones: (state: RootState) => state.timeZones,
	getUlTypes: (state: RootState) => state.ulTypes,
	getCanAddIndividualActionsOverride: (state: RootState) => state.User.canAddIndividualActionsOverride,
	accountCreationEnabled: (state: RootState) => state.accountCreationStatus,
	getDynamicLinkConfig: (state: RootState) => state.User.dynamicLinkConfig,
	getPreviousRoute: (state: RootState) => state.previousRoute,
	getCurrentClipCells: (state: RootState) => state.currentClipCells,

	/**
	 * Gets system login preferences
	 */
	loginPreferences: (state: RootState) => state.loginPreferences,
	getCustomMapViewTypes: (state: RootState) =>  {
		let customMapViewTypes: string[] = [];

		const mapsLightEnhancedZoomFeature: string[] =  ["CustomMapViewTypes", "EnhancedZoomLightEnabled"];
		const mapsLightEnhancedZoomFeatureEnabled: boolean = get(state.featuresList, mapsLightEnhancedZoomFeature, false);

		if (mapsLightEnhancedZoomFeatureEnabled) {
			customMapViewTypes.push("EnhancedZoomWhite")
		}

		return customMapViewTypes;
	}
};
